export default "__VITE_ASSET__DuHi74Za__"